import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SEO from "@/components/SEO";
import { useTranslation } from "react-i18next";
import { processInvitationsAfterSignUp } from "@/store/invitations/invitationActions";
import loadingIcon from "@/images/loader.gif";
import AvatarUploadForm, { MAX_AVATAR_BYTES } from "./AvatarUploadForm";

interface AvatarUploadProps {
  isOpen: boolean;
  closeModal: () => void;
}

const AvatarUpload = ({ isOpen, closeModal }: AvatarUploadProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["translation.AvatarUpload"]);

  const isSavingAvatar = useSelector((state: any) =>
    Boolean(state.profile.pageMetaData.get("isSavingAvatar"))
  );
  const avatar = useSelector((state: any) => state.profile.avatar);
  const isSignup = useSelector((state: any) => Boolean(state.metadata.isSignup));

  const skip = () => {
    if (isSignup) dispatch(processInvitationsAfterSignUp());
    closeModal();
  };

  const renderSaveButton = (image?: File | null) => {
    if (isSavingAvatar) {
      return <img alt="loading icon" src={loadingIcon} />;
    }
    return (
      <Button
        type="submit"
        variant="contained"
        disabled={!image || image.size > MAX_AVATAR_BYTES}
      >
        {t("save")}
      </Button>
    );
  };

  return (
    <SEO title="Add a profile photo">
      <Dialog
        open={isOpen}
        onClose={skip}
        maxWidth={false}
        slotProps={{ paper: { "aria-label": "Avatar Upload Modal" } }}
      >
        <DialogContent>
          <IconButton
            onClick={skip}
            aria-label={t("close")}
            sx={{ display: "block", ml: "auto", color: "grey.600" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <AvatarUploadForm
            renderSaveButton={renderSaveButton}
            skip={skip}
            avatar={avatar}
            isSignup={isSignup}
          />
        </DialogContent>
      </Dialog>
    </SEO>
  );
};

export default AvatarUpload;
